import {formatMoney} from '../../utils/format-money';

export const expenseLineAmountLabel = (data) => data.t.read('approval_requests_table.expense_line_amount');

export default function ReceiptTotals({data, receipts = []}) {
    const uniqueReceipts = [...new Map(receipts.map((receipt) => [receipt.id, receipt])).values()];
    if (!uniqueReceipts.length) return <span>{data.t.read('approval_requests_table.receipt_unavailable')}</span>;

    return uniqueReceipts.map((receipt) => (
        <div key={receipt.id}>
            {receipt.name && <div className="text-muted">{receipt.name}</div>}
            <strong>{receipt.total == null
                ? data.t.read('approval_requests_table.receipt_unavailable')
                : formatMoney(receipt.total, receipt.currency || null)}</strong>
        </div>
    ));
}
